/** ****************************************************************************
 * This constants file has constants for the iFrame class names.
 *
 * In order for the iFrame to have custom CSS injection, everyone must
 * use the same class names (as any API would have), so this file represents
 * the class names for custom CSS injection.
 *
 * @file   Constants file, iFrame class names
 * @author Paul J Stales
 * @since  2.3.0
 **************************************************************************** */

/**
 * Class Names for the iFrame
 * These names MUST stay constant, partners depend on these names!
 *
 * AGAIN, >>> DO NOT <<< CHANGE THESE NAMES - PARTNERS USE THEM AS AN API!
 */
export const IFRAME_CLASSNAMES = {
  BPERX_CHANGE_SELECTION_BUTTON: 'bperx_change_selection_button',
  BPERX_CHANGE_SELECTION_BUTTON_CONTAINER:
    'bperx_change_selection_button_container',
  BPERX_CHOSEN_MAGAZINE_IMAGE: 'bperx_chosen_magazine_image',
  BPERX_CHOSEN_MAGAZINE_ISSUES: 'bperx_chosen_magazine_issues',
  BPERX_CHOSEN_MAGAZINE_TEXT: 'bperx_chosen_magazine_text',
  BPERX_CHOSEN_MAGAZINE_TITLE: 'bperx_chosen_magazine_title',
  BPERX_LABEL_OPT_CHECKBOX: 'bperx_label_opt_checkbox',
  BPERX_MAGAZINE_IMAGE_SUBCONTAINER: 'bperx_magazine_image_subcontainer',
  BPERX_NO_AUTO_RENEW_TEXT: 'bperx_no_auto_renew_text',
  BPERX_OFFER_INFORMATION_SUBCONTAINER: 'bperx_offer_information_subcontainer',
  BPERX_OFFER_TITLE_TEXT: 'bperx_offer_title_text',
  BPERX_OPT_CHECKBOX: 'bperx_opt_checkbox',
  BPERX_OPT_CHECKBOX_CONTAINER: 'bperx_opt_checkbox_container',
  BPERX_PRODUCTS_CONTAINER: 'bperx_products_container',
  BPERX_PRODUCTS_LIST_CONTAINER: 'bperx_products_list_container',
  BPERX_PRODUCT_ITEM_CONTAINER: 'bperx_product_item_container',
  BPERX_PRODUCT_ITEM_IMAGE: 'bperx_product_item_image',
  BPERX_PRODUCT_ITEM_TITLE: 'bperx_product_item_title',
  BPERX_SELECTED_OFFER_CONTAINER: 'bperx_selected_offer_container',
  BPERX_SELECTED_OFFER_TERMS_CHEVRON: 'bperx_selected_offer_terms_chevron',
  BPERX_SELECTED_OFFER_TERMS_LINK: 'bperx_selected_offer_terms_link',
  BPERX_SELECTED_OFFER_TERMS_TEXT: 'bperx_selected_offer_terms_text',
  BPERX_SELECTED_OFFER_TERMS_TEXT_VISIBLE_FALSE:
    'bperx_selected_offer_terms_text_visible_false',
  BPERX_USER_INTERACTION_CONTAINER: 'bperx_user_interaction_container',
  __________BPERX_IFRAME__________: '__________BPERX_IFRAME__________'
}
